import React from 'react'
import { Tooltip } from '@material-ui/core'

const NotificationBadge = ({ localizedId, imageAsset }) => {
  return (
    <>
      <Tooltip title={localizedId}>
        <img
          className="w-12 align-middle self-center mb-1"
          src={imageAsset}
          alt="notification badge"
        />
      </Tooltip>
    </>
  )
}

export default NotificationBadge
